import script from "./contactUS.vue?vue&type=script&setup=true&lang=js"
export * from "./contactUS.vue?vue&type=script&setup=true&lang=js"

import "./contactUS.vue?vue&type=style&index=0&id=cbce9bbe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbce9bbe"]])

export default __exports__